import * as angular from 'angular';
import { StateService } from '@uirouter/angularjs';

import { ComponentDefinition, ContextualField, PropertyType }
    from '../../../models/index';
import { ButtonWidgetConfiguration } from '../button.widget';

class ButtonContextualController implements angular.IComponentController {

    configuration: ButtonWidgetConfiguration;
    formController: angular.IFormController;
    properties: ContextualField[];
    save: () => void;
    cancel: () => void;

    private _originalConfiguration: ButtonWidgetConfiguration;

    static $inject = ['$q', '$state'];

    constructor(
        private _$q: angular.IQService,
        private _$state: StateService
    ) {
    }

    $onInit() {
        const states = this._$state.get()
            .filter(s => !s.abstract && s.data.displayName)
            .map(s => {
                return { key: s.name, value: s.data.displayName };
            })
            .sort((a, b) => a.value < b.value ? -1 : 1);
        this.properties = [
            {
                modelName: 'hasIcon',
                propertyType: PropertyType.Boolean,
                label: 'Show icon',
                placeholder: 'Show icon',
                propertyName: 'hasIconProperty',
                required: false,
                icon: 'fa-font-awesome'
            },
            {
                modelName: 'hasLabel',
                propertyType: PropertyType.Boolean,
                label: 'Show label',
                placeholder: 'Show label',
                propertyName: 'hasLabelProperty',
                required: false,
                icon: 'fa-font'
            },
            {
                modelName: 'label',
                propertyType: PropertyType.Text,
                label: 'Label',
                placeholder: 'Label',
                propertyName: 'labelProperty',
                required: false,
                icon: 'fa-font'
            },
            {
                modelName: 'destination',
                propertyType: PropertyType.Select,
                label: 'Destination',
                placeholder: 'Destination',
                propertyName: 'destinationProperty',
                required: false,
                icon: 'fa-compass',
                extraData: {
                    options: states
                }
            }
        ];
    }

    onSave(): angular.IPromise<void> {
        return this._$q.when(this.save());
    }

    onCancel() {
        this.configuration = angular.copy(this._originalConfiguration);
        this.cancel();
    }
}

export const wtButtonContextual: ComponentDefinition = {
    componentId: 'wtButtonContextual',
    controller: ButtonContextualController,
    template: require('./buttonContextual.component.html'),
    controllerAs: 'vm',
    bindings: {
        configuration: '<',
        formController: '=',
        save: '&?',
        cancel: '&?'
    }
};